<template>
  <i class="ri-close-line text-lg absolute right-2 top-0 text-[#000000] cursor-pointer" @click="$emit('close')"></i>
  <div class="w-full max-w-[50rem]">
    <div class="flex justify-center mb-3">
      <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_BASE_PATH}Hover.svg`" alt="Hover" class="h-[48px] w-[177px]" />
    </div>

    <h2 class="text-[26px] text-[#464646] text-center font-semibold mb-2">
      {{ $t('hover.heading') }}
    </h2>

    <Loader v-if="hoverStore.loading" />
    <AccountNotExist v-else-if="!hoverStore.isHoverConfigured" />
    <div class="w-full flex justify-center mt-4 block">
      <button class="text-[#171717] text-base bg-[#fff] sm:inline-block sm:ml-2.5 mr-4" @click="$emit('close')">
        {{ $t('integration.cancel') }}
      </button>
    </div>

  </div>
</template>

<script setup>
import { useHoverStore } from '@/stores/hoverStore';
import AccountNotExist from '@/components/Reports/AccountNotExist.vue';
import { onMounted } from 'vue';
import Loader from '@/components/atoms/Loader.vue';
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_BASE_PATH } from "@/config/constants.js";
import { useI18n } from "vue-i18n";
import { getLanguage } from '@/utilities/cookies';

const { t, locale } = useI18n();
locale.value = getLanguage();

const hoverStore = useHoverStore();

const props = defineProps({
  redirectRoute: String,
})

const emit = defineEmits(['close']);

onMounted(async () => {
  await hoverStore.connectToHover();
})
</script>